module.exports = __webpack_public_path__ + "img/96.e044845a.jpg";